module.exports = __webpack_public_path__ + "img/dashboard-icon.d11b644b.svg";